import { Edge, Node } from '@xyflow/react'
import { IWizardBlock } from './wizard-types'
export enum IEdgeType {
    CUSTOM_EDGE = 'custom-edge',
}

export enum INodeType {
    TRIGGER = 'trigger',
    ACTION = 'action',
    EMPTY_TRIGGER = 'emptyTrigger',
    PLACEHOLDER_NODE = 'placeholderNode',
    PLACEHOLDER_CONDITION = 'placeholderCondition',
    LOOP = 'loop',
    CONDITION_GROUP = 'condition_group',
    UTILITY = 'utility',
    CONDITION = 'condition',
}

export type FlowElementsType = {
    nodes: Node<IWizardBlock>[]
    edges: Edge[]
}
